import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, HeaderComponent, SidebarComponent],
  host: { class: 'block h-screen' },
  template: `
    <!-- DaisyUI Drawer: sidebar sempre visibile su lg, toggle su mobile -->
    <div class="drawer lg:drawer-open h-full">
      <input id="admin-drawer" type="checkbox" class="drawer-toggle" />

      <!-- Contenuto principale -->
      <div class="drawer-content flex flex-col h-full overflow-hidden">
        <app-header drawerId="admin-drawer" />
        <main class="flex-1 p-6 bg-base-100 overflow-y-auto">
          <router-outlet />
        </main>
      </div>

      <!-- Sidebar -->
      <div class="drawer-side z-10">
        <label for="admin-drawer" aria-label="Chiudi menu" class="drawer-overlay"></label>
        <aside class="w-64 h-full">
          <app-sidebar />
        </aside>
      </div>
    </div>
  `,
  styles: ``
})
export class ShellComponent {}